const LOG_PREFIX = '[ExplorationCanvas]';

export function traceExplorationCanvas(
  message: string,
  data?: Record<string, unknown>
): void {
  if (!import.meta.env.DEV) return;
  if (data) {
    console.debug(LOG_PREFIX, message, data);
  } else {
    console.debug(LOG_PREFIX, message);
  }
}
